import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	goBackButton: {
		id: 'issue-field-status.status-view.actions.actions-menu.recur-work-container.go-back-button-non-final',
		defaultMessage: 'Set recurring',
		description: 'The label for the button that takes users to the main popup screen',
	},
});
